import { useState } from "react";
import { useApiConfig } from "./context";
import { setCache } from "./cache";

export function useMutation<T = any>(
  url: string,
  method: string = "POST",
  { optimisticKey }: { optimisticKey?: string } = {}
) {
  const { baseURL, headers, getToken } = useApiConfig();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>(null);
  const [data, setData] = useState<T | null>(null);

  const mutate = async (body?: any, optimisticData?: any) => {
    setLoading(true);
    setError(null);

    if (optimisticKey && optimisticData) {
      setCache(optimisticKey, optimisticData);
    }

    try {
      const token = getToken?.();
      const res = await fetch(`${baseURL || ""}${url}`, {
        method,
        headers: {
          "Content-Type": "application/json",
          ...headers,
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: body ? JSON.stringify(body) : undefined,
      });

      if (!res.ok) throw new Error(await res.text());
      const json = await res.json();
      setData(json);

      if (optimisticKey) setCache(optimisticKey, json);
      return json;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { mutate, data, loading, error };
}
